import { RecordDateFilterComponentModule } from '@/src/app/features/reports/components/report-filters/components/record-date-filter/record-date-filter.component';
import { SearchModule } from '@/src/app/features/search/search.module';
import { FormModule } from '@/src/app/shared/components/form/form.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FormsCommonsModule } from '@shared/modules/forms-commons/forms-commons.module';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';
import { ReadonlyCommonsModule } from '@shared/modules/readonly-commons/readonly-commons.module';

import { SuspiciousRecordReasonDialogComponent } from './components/suspicious-record-reason-dialog/suspicious-record-reason-dialog.component';
import { SuspiciousRecordComponent } from './components/suspicious-record/suspicious-record.component';
import { SuspiciousRecordsComparisonPageComponent } from './components/suspicious-records-comparison-page/suspicious-records-comparison-page.component';
import { SuspiciousRecordsSearchPageComponent } from './components/suspicious-records-search-page/suspicious-records-search-page.component';
import { ScrollableContainerComponent } from '@shared/components/scrollable-container/scrollable-container.component';

@NgModule({
  imports: [
    CommonModule,
    FormModule,
    ReactiveFormsModule,
    RecordDateFilterComponentModule,
    SearchModule,
    TranslateModule.forChild(),
    RouterModule,
    ReadonlyCommonsModule,
    GeneralCommonsModule,
    FormsCommonsModule,
    ScrollableContainerComponent,
    SuspiciousRecordsSearchPageComponent,
    SuspiciousRecordsComparisonPageComponent,
    SuspiciousRecordComponent,
    SuspiciousRecordReasonDialogComponent
  ]
})
export class SuspiciousRecordsReviewModule {}
